import React from "react";
import { useParams, Navigate } from "react-router-dom";
import MenuBar from "@/components/MenuBar";
import { useLocalizedInterview } from "@/hooks/useLocalizedInterviews";
import InterviewCard from "@/components/interview/InterviewCard";

const ArticlePage = () => {
  const { id } = useParams<{ id: string }>();
  const { data: interview, isLoading, error } = useLocalizedInterview(id || '');

  if (!id) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="min-h-screen bg-background">
      <MenuBar />
      <div className="max-w-4xl mx-auto px-4 pt-2 md:pt-4 pb-6">
        {isLoading && (
          <div className="flex justify-center items-center py-12">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
          </div>
        )}
        
        {error && (
          <div className="text-center py-12">
            <p className="text-muted-foreground">Kunne ikke laste artikkel</p>
          </div>
        )}
        
        {interview && <InterviewCard {...interview} />}
        
        {!isLoading && !error && !interview && (
          <div className="text-center py-12">
            <p className="text-muted-foreground">Artikkel ikke funnet</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ArticlePage;
